import * as App from "@timesheets/routes-app";

import { Roles, Timesheet } from "@timesheets/constants-common";

import { IGroupRoute } from "./IGroupRoute";
import { PageTypes } from "./PageTypes";
import { Route } from "@gemma/utils";
import { Routing } from "@timesheets/webapp-support";
import { TRouteMetaGroup } from "./TRouteMetaGroup";
import { WireEntities } from "@timesheets/common";
import { redirectToRolesList } from "./redirectToRolesList";

export function redirectToTimesheetsWhenOnlyOneRole(pageType: PageTypes, roles: WireEntities.Roles.IRecruitmentAgencyRole[], role: WireEntities.Roles.IRecruitmentAgencyRole, to: IGroupRoute): Routing.RouteResult<TRouteMetaGroup> {
  if (App.isRedirectableRoute(to.path)) {
    if (roles.length === 1) {
      switch (role.type) {
        case Roles.ContractingRole.TypeName:
        case Roles.AuthorisingRole.TypeName: {
          const route = new Route<TRouteMetaGroup>(`/${Timesheet.Behaviour.CollectionNameLower}`, { roleId: role.id });
          if (pageType === PageTypes.AccountPages) {
            return { continue: false, route };
          } else {
            return { continue: true, route };
          }
        }

        default:
          break;
      }
    }

    return redirectToRolesList(pageType, to);
  }

  // Continue with route
  return { continue: true, route: undefined };
}
